class ReloadSection extends HTMLElement {
  constructor() {
    super();

    this.section = this.dataset.section;
    this.productRenderer = document.querySelector('product-renderer');
    if (!this.productRenderer.dataset.alt) {
      this.classList.remove('loading');
      //return;
    }

    if (this.productRenderer) {
      if (!this.productRenderer.dataset.alt) return;
      this.specificProduct = this.productRenderer.dataset.handle;
      this.dataPart = this.dataset.part;
      if (this.id == 'reload-section-product') {
        this.renderNewProductSection(this.specificProduct, this.section);
      } else {
        this.renderNewSection(this.specificProduct, this.section, this.dataPart);
      }

      
    }

  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionInnerHTMLNew(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }


  renderNewSection(product, section, part) {

    if (part) {
      var newSectionToRender = `[data-section="${section}"] .${part}`;
      var oldSection = this.querySelector(`.${part}`);
    } else {
      var newSectionToRender = `[data-section="${section}"]`;
      var oldSection = this;

    }

    let rootUrl = routes.root_url;
    if (!rootUrl.endsWith("/")) {
      rootUrl = rootUrl + "/";
    }

    const sectionUrl = `${rootUrl}products/${product}?section_id=${section}`;

    fetch(sectionUrl)
    .then((response) => { 
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      return response.text();
    })
      .then((text) => {

        oldSection.innerHTML = this.getSectionInnerHTML(text, newSectionToRender);
    })
    .catch((error) => {
      throw error;
    }); 
    
  }

  renderNewProductSection(product, section) {
    const sectionUrl = `${routes.root_url}products/${product}?section_id=${section}`;
    fetch(sectionUrl)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      return response.text();
    })
      .then((text) => {
        this.getProductSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
          elementToReplace.innerHTML =
          this.getSectionInnerHTMLNew(text, section.selector);

        
        }));
        this.classList.remove('loading');
        toggleReadMore();


    }).catch((error) => {
      throw error;
    });
  }

  getProductSectionsToRender() {
    return [
      {
        id: 'reload-section-product',
        section: document.getElementById('reload-section-product').dataset.section,
        selector: '.js-contents',
      },
      {
        id: 'reload-section-product',
        section: document.getElementById('reload-section-product').dataset.section,
        selector: '.js-featured',
      },
      {
        id: 'reload-section-product',
        section: document.getElementById('reload-section-product').dataset.section,
        selector: '.js-text',
      },
      {
        id: 'reload-section-product',
        section: document.getElementById('reload-section-product').dataset.section,
        selector: '.js-title',
      }
    ];
  }



}
  

  
  customElements.define('reload-section', ReloadSection);
  